// NewsletterPopup.js
import React, { Component } from 'react';
import API_Root from '../Constants/API_Root';
import { toggleToast } from "../Actions/ToggleToast";

class NewsletterPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      firstName: "",
      lastName: ""
    };
  }

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleSubmit = () => {
    const { email, firstName, lastName } = this.state;
    // Send a POST request to subscribe the user
    fetch(API_Root + 'subscription/subscribe-to-newsletter', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        email,
        firstName,
        lastName
      })
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        this.props.toggleToast && this.props.toggleToast({
          show: true,
          type: "success",
          message: "Successfully subscribed to the newsletter!"
        });
        this.props.onClose();
      })
      .catch(error => {
        console.error('There was a problem with the fetch operation:', error);
        this.props.toggleToast && this.props.toggleToast({
          show: true,
          type: "error",
          message: "Failed to subscribe to the newsletter."
        });
      });
  }

  render() {
    const overlayStyle = {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.7)', // black with 70% opacity
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000
    };

    const modalStyle = {
      position: 'relative',
      background: '#fff',
      padding: '20px',
      borderRadius: '8px',
      width: '350px',
      textAlign: 'center'
    };

    const closeButtonStyle = {
      position: 'absolute',
      top: '10px',
      right: '10px',
      background: '#3D826D',
      border: 'none',
      fontSize: '16px',
      cursor: 'pointer',
      borderRadius: '23px',
      width: '25px',
      height: '25px',
      color: '#fff'
    };

    const inputStyle = {
      width: '100%',
      padding: '8px',
      marginBottom: '10px',
      borderRadius: '4px',
      border: '1px solid #ccc'
    };

    const buttonStyle = {
      padding: '10px 20px',
      backgroundColor: '#3E826D',
      color: 'white',
      border: 'none',
      borderRadius: '4px',
      cursor: 'pointer'
    };

    return (
      <div style={overlayStyle}>
        <div style={modalStyle}>
          <button style={closeButtonStyle} onClick={this.props.onClose} aria-label="Close popup">&times;</button>
          <h3>Sign up to our IFI disclosures Newsletter</h3>
          <input
            style={inputStyle}
            type="email"
            name="email"
            placeholder="Email"
            value={this.state.email}
            onChange={this.handleChange}
          />
          <input
            style={inputStyle}
            type="text"
            name="firstName"
            placeholder="First Name"
            value={this.state.firstName}
            onChange={this.handleChange}
          />
          <input
            style={inputStyle}
            type="text"
            name="lastName"
            placeholder="Last Name"
            value={this.state.lastName}
            onChange={this.handleChange}
          />
          <button style={buttonStyle} onClick={this.handleSubmit}>Sign Up</button>
        </div>
      </div>
    );
  }
}

export default NewsletterPopup;
